module.exports = __webpack_public_path__ + "media/images/svg-icon/widgets-6d225c2206beb868557eed1ef44c92e6.svg";